import { HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton/enums/HelpSection'

export const personalSystemsKbaseLinks = {
  [HelpSection.ProgramOfferings]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1588/aid/4222',
  [HelpSection.Completeness]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4665',
  [HelpSection.BasicInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4673',
  [HelpSection.ContactInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4674',
  [HelpSection.HpContact]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4675',
  [HelpSection.TranslationFactors]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4676',
  [HelpSection.MarketInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4677',
  [HelpSection.FinancialAndSOB]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4678',
  [HelpSection.TopDeal]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4679',
  [HelpSection.LongTerm]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4680',
  [HelpSection.KeyInitiatives]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4814',
  [HelpSection.Bridges]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4682',
  [HelpSection.MDFPlanning]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4683',
  [HelpSection.Graphs]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4684',
  [HelpSection.MasterDealer]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4685',
  [HelpSection.PBMAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4825',
  [HelpSection.ManagerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4826',
  [HelpSection.PartnerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4827',
  [HelpSection.HistoryAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1651/aid/4828',
}
